import { PromoBOID } from 'core/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { ServicePlanPromo } from './service-plan-promo';

export class ServicePromoEligibility extends ModelBase {
    public static storeName: string = 'servicePromoEligibility';

    public isPromoEligible: boolean;
    public promotions: ServicePlanPromo[];
    public servicePromo: ServicePlanPromo;
    public nonByoServicePromotion: ServicePlanPromo; // used to store either NewUser or ExistingUser(bogo) Promotion //
    public byoServicePromotion: ServicePlanPromo;
    public hasConcurrentpromotion: boolean;
    public servicePromotionTotal: number;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public static create<T extends ModelBase>(initData: ApiResponse): T {
        const toReturn: ServicePromoEligibility = super.create<ServicePromoEligibility>(initData);

        toReturn.nonByoServicePromotion = (toReturn.isPromoEligible && toReturn.promotions.length > 0 && toReturn.promotions.filter(promo => promo.promoBOID !== PromoBOID.BYOD_LL_SERP)[0]);
        toReturn.byoServicePromotion = (toReturn.isPromoEligible && toReturn.promotions.length > 0 && toReturn.promotions.filter(promo => promo.promoBOID === PromoBOID.BYOD_LL_SERP)[0]);
        toReturn.hasConcurrentpromotion = Boolean(toReturn.nonByoServicePromotion && toReturn.byoServicePromotion);
        toReturn.servicePromotionTotal = Number(toReturn.nonByoServicePromotion?.valueTotal || 0) + Number(toReturn.byoServicePromotion?.valueTotal || 0);

        return <T><any>toReturn;
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'promotions',
            model: ServicePlanPromo
        }];
    }

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'servicePromo',
            model: ServicePlanPromo
        }];
    }

    public getHighestServicePromo(promos: ServicePlanPromo[]): ServicePlanPromo {
        return promos.length > 0
            ? promos.reduce((prev, current) => (prev.valueTotal >= current.valueTotal ? prev : current))
            : undefined;
    }
}